import { CampaignuiBaseColumn } from '@bingads-webui-campaign/campaignui-base-column';
import clickableValueTemplate from './clickable-value.pug';

export class ListNameColumn extends CampaignuiBaseColumn {
  constructor({ i18n, scope }) {
    super({
      name: 'Name',
      property: ['SharedEntityName', 'SharedEntityId'],
      title: i18n.getString('ColumnName_NegativeKeywordList_Name'),
      sortable: 'SharedEntityName',
      type: 'string',
      bodyClasses: ['grid-column-negative-keyword-list-name'],
    });

    this.scope = scope;
    this.i18n = i18n;
  }

  pickProperty({ SharedEntityId, SharedEntityName }) {
    const { customerId: cid, accountId: aid } = this.scope;

    return {
      name: SharedEntityName,
      nkl: SharedEntityId,
      cid,
      aid,
      pathname: '/campaign/vnext/negativekeywordslistsdetails/negativekeywords',
      href: `/campaign/vnext/negativekeywordslistsdetails/negativekeywords?cid=${cid}&aid=${aid}&nkl=${SharedEntityId}`,
      customparams: `nkl=${SharedEntityId}`,
      ariaLabel: this.i18n.getString('Click to open negative keywords list {{nklName}}', { nklName: SharedEntityName }),
    };
  }

  get template() { return clickableValueTemplate; }
}
